import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../../state-management/rootReducer';
import { AppStatus } from '../enums';

const initialState: ApplicationSubmission = {
  appId: '',
  appUrn: '',
  listingId: '',
  listingName: '',
  version: '',
  versionId: '',
  urlPath: '',
  appType: '',
  description: '',
  shortDescription: '',
  status: AppStatus.DEVELOPMENT,
  isPrivate: false,
  consoleCompatible: false,
  isMultiTenant: false,
  honorsCopyright: false,
  appUrls: [],
  categories: [],
};

export const applicationSubmissionSlice = createSlice({
  name: 'applicationSubmission',
  initialState: initialState,
  reducers: {
    setApplicationSubmission: (
      state: ApplicationSubmission,
      action: PayloadAction<ApplicationSubmission>
    ) => {
      return action.payload;
    },
  },
});

export const { setApplicationSubmission } = applicationSubmissionSlice.actions;

export const getApplicationSubmission = (state: RootState) =>
  state.applicationSubmission;

export default applicationSubmissionSlice.reducer;
